<template>
  <div class="week-single">
    <template v-if="mainScreenSteps.includes(question.id)">
      <CancellationDisplayList
        v-if="question.id === 3.51"
        :question="question"
        @submitAnswer="forward"
      />
      <CancellationCheckbox
        v-else-if="question.id === 3.71"
        :question="question"
        @submitAnswer="forward"
      />
      <CancellationGeneric
        v-else
        :question="question"
        @submitAnswer="forward"
      />
    </template>

    <TreatmentDose
      v-else-if="question.id === 11"
      :question="question"
      :composite="composite"
      @submitAnswer="forward"
    />

    <InfoScreen
      v-else-if="infoScreenIds.includes(question.id)"
      :question="question"
      @submitAnswer="forward"
    />

    <AccordionDisplay
      v-else-if="hasDisplayArray"
      :question="question"
      @submitAnswer="forward"
    />

    <RadioList
      v-else
      :question="question"
      :composite="composite"
      @submitAnswer="forward"
    />
  </div>
</template>

<script>
import CancellationDisplayList from './CancellationDisplayList.vue';
import CancellationCheckbox from './CancellationCheckbox.vue';
import CancellationGeneric from './CancellationGeneric.vue';
import TreatmentDose from './TreatmentDose.vue';
import InfoScreen from './InfoScreen.vue';
import AccordionDisplay from './AccordionDisplay.vue';
import RadioList from './RadioList.vue';

export default {
  components: {
    CancellationDisplayList,
    CancellationCheckbox,
    CancellationGeneric,
    TreatmentDose,
    InfoScreen,
    AccordionDisplay,
    RadioList,
  },
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    composite: {
      type: Boolean,
      default: false,
    },
    mainScreenSteps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      infoScreenIds: [
        1, 2, 3.33, 3.41, 3.51, 3.81, 4.1, 4.3, 6.1, 7.1, 7.5, 8.1, 8.3, 9.3,
        11.1, 11.2,
      ],
    };
  },
  computed: {
    hasDisplayArray() {
      return Object.prototype.hasOwnProperty.call(this.question, 'displayArray');
    },
  },
  methods: {
    forward(payload) {
      this.$emit('submitAnswer', payload);
    },
  },
};
</script>

